/** Link widget display options (stored on grid item when type === 'link'). */

export const LINK_DISPLAY_URL = 'url';
export const LINK_DISPLAY_BUTTON = 'button';

export const LINK_SHAPE_PILL = 'pill';
export const LINK_SHAPE_ROUNDED = 'rounded';
export const LINK_SHAPE_SQUARE = 'square';

export const DEFAULT_LINK_BUTTON_BG = '#3b82f6';
export const DEFAULT_LINK_BUTTON_FG = '#ffffff';
export const DEFAULT_LINK_BUTTON_SHAPE = LINK_SHAPE_ROUNDED;

export const LINK_BUTTON_SIZE_SM = 'sm';
export const LINK_BUTTON_SIZE_MD = 'md';
export const LINK_BUTTON_SIZE_LG = 'lg';
export const DEFAULT_LINK_BUTTON_SIZE = LINK_BUTTON_SIZE_MD;

export function linkButtonShapeToBorderRadius(shape) {
  if (shape === LINK_SHAPE_SQUARE) return 0;
  if (shape === LINK_SHAPE_PILL) return 9999;
  return 10;
}

export function getLinkDisplayMode(item) {
  return item?.linkDisplayMode === LINK_DISPLAY_BUTTON ? LINK_DISPLAY_BUTTON : LINK_DISPLAY_URL;
}

export function getLinkButtonLabel(item) {
  const raw = item?.linkButtonLabel;
  if (raw != null && String(raw).trim() !== '') return String(raw).trim();
  return 'Open link';
}

export function getLinkButtonBg(item) {
  return item?.linkButtonBg || DEFAULT_LINK_BUTTON_BG;
}

export function getLinkButtonFg(item) {
  return item?.linkButtonFg || DEFAULT_LINK_BUTTON_FG;
}

export function getLinkButtonShape(item) {
  const s = item?.linkButtonShape;
  if (s === LINK_SHAPE_PILL || s === LINK_SHAPE_ROUNDED || s === LINK_SHAPE_SQUARE) return s;
  return DEFAULT_LINK_BUTTON_SHAPE;
}

export function getLinkButtonSize(item) {
  const s = item?.linkButtonSize;
  if (s === LINK_BUTTON_SIZE_SM || s === LINK_BUTTON_SIZE_MD || s === LINK_BUTTON_SIZE_LG) return s;
  return DEFAULT_LINK_BUTTON_SIZE;
}

/**
 * Padding and label font size for link-as-button (compact = grid editor / small previews).
 */
export function getLinkButtonMetrics(size, compact = false) {
  const sz = size === LINK_BUTTON_SIZE_SM || size === LINK_BUTTON_SIZE_LG ? size : LINK_BUTTON_SIZE_MD;
  if (compact) {
    if (sz === LINK_BUTTON_SIZE_SM) return { padH: 8, padV: 3, fontSize: 9 };
    if (sz === LINK_BUTTON_SIZE_LG) return { padH: 12, padV: 6, fontSize: 12 };
    return { padH: 10, padV: 4, fontSize: 10 };
  }
  if (sz === LINK_BUTTON_SIZE_SM) return { padH: 10, padV: 4, fontSize: 10 };
  if (sz === LINK_BUTTON_SIZE_LG) return { padH: 20, padV: 11, fontSize: 15 };
  return { padH: 14, padV: 7, fontSize: 12 };
}
